import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import styles from './Button.module.scss';

const ApeButton = ({
  isDisabled, isLoading, onClick, actionLabel, className = '', actionIcon,
}: ButtonProps) => (
  <button className={`apeButton ${className} ${styles.submitButton} 
    ${isLoading ? styles.loading : ''} ${isDisabled ? styles.disabled : ''}`}
    type="button" onClick={() => onClick()} disabled={isDisabled}>{actionLabel} {actionIcon}
    {isLoading && <CircularProgress size={20} />}
  </button>);
export default ApeButton;
